<template>
  <div class="login-dialog-btn">
    <el-button class="login-btn" @click="onLoginClick">登录/注册</el-button>
    <el-dialog
      title=""
      class="login-dialog"
      :visible.sync="dialogVisible"
      width="909px"
      :modal-append-to-body=false
      >
      <div class="row login-dialog-content">
        <div class="login-dialog-content-left">
          <div class="title">尊敬的游客您好，</div>
          <div class="second-title">欢迎访问和使用研报酷。</div>
          <div class="content">目前是游客身份，不能使用翻页、下载、收藏等功能，
            注册成为研报酷的用户后，可在15天内试用产品的绝大部分功能，
            之后您可以再行决定是否付费继续使用我们的服务。
          </div>
          <div class="prompt">注册成功送“15日会员”！！！</div>
          <img src="../../assets/img/login-illustrations.svg" alt="">
          <el-button class="login-left-btn" @click="onKnowBtnClick">我已知晓</el-button>
        </div>
        <div class="login-dialog-content-right">
          <div class="login-dialog-content-right-content">
            <img class="login-right-img" src="../../assets/img/logo.svg" alt="">
            <div class="row login-register-tab">
              <div class="tab-btn" :class="{'active': selectedOptionTab === 'login'}" @click="onChooseDialogTab('login')">登录</div>
              <div class="tab-btn" :class="{'active': selectedOptionTab === 'register'}" @click="onChooseDialogTab('register')">注册</div>
            </div>
            <div class="login-message">
              <div class="password-login" v-if="isPasswordLogin && selectedOptionTab === 'login'">
                <input @focus="usernameLoginInputFocus" type="text" class="login-register-input" placeholder="用户名/手机号/邮箱" v-model.trim="usernameLoginInput"/>
                <div class="input-error">{{usernameLoginUsernameError}}</div>
                <input @focus="usernamePasswordLoginInputFocus" type="password" class="password-input login-register-input" placeholder="请输入密码" v-model.trim="usernamePasswordLoginInput"/>
                <div class="input-error">{{usernameLoginPasswordError}}</div>
                <div class="change-way" @click="onChooseVerificationLogin">手机验证码登录</div>
              </div>    
              <div class="tel-login" v-if="!isPasswordLogin && selectedOptionTab === 'login'">
                <input @focus="verificationCodeLoginInputFocus" type="text" class="login-register-input" placeholder="请输入手机号" v-model.trim="telLoginInput"/>
                <div class="input-error">{{verificationCodeLoginTelError}}</div>
                <div class="row">
                  <input @focus="verificationCodeInputFocus" type="text" class="verification-code-input login-register-input" placeholder="请输入验证码" v-model.trim="verificationCodeLoginInput"/>
                  <el-button v-if="showLoginCodeBtn" @click="onSendLoginCodeClick" class="verification-code-btn">获取验证码</el-button>
                  <el-button v-else class="verification-code-btn">{{time}}s</el-button>
                </div>
                <div class="input-error">{{verificationCodeLoginCodeError}}</div>
                <div class="change-password-way change-way" @click="onChoosePasswordLogin">密码登录</div>
              </div> 
              <div class="tel-register" v-if="selectedOptionTab === 'register'">
                <input @focus="telRegisterInputFocus" type="text" class="login-register-input" placeholder="请输入手机号" v-model.trim="telRegisterInput"/>
                <div class="input-error">{{registerTelError}}</div>
                <input @focus="passwordRegisterInputFocus" type="password" class="password-input login-register-input" placeholder="请输入密码" v-model.trim="passwordRegisterInput"/>
                <div class="input-error">{{registerPasswordError}}</div>
                <div class="row">
                  <input @focus="verificationCodeRegisterInputFocus" type="text" class="verification-code-input login-register-input" placeholder="请输入验证码" v-model.trim="verificationCodeRegisterInput"/>
                  <el-button v-if="showCodeBtn" @click="onSendCodeClick" class="verification-code-btn">获取验证码</el-button>
                  <el-button v-else class="verification-code-btn">{{time}}s</el-button>
                </div>
                <div class="input-error">{{registerVerificationError}}</div>
              </div>
            </div>
            <div class="login-register-btn">
              <div @click="onDialogLoginClick" v-if="selectedOptionTab === 'login'" class="login--btn">登录</div>
              <div @click="onRegisterClick" v-if="selectedOptionTab === 'register'" class="login--btn">注册</div>
              <a :href="redirectUri">
                <div class="vx-login--btn">
                  <img class="wechat-img" src="../../assets/img/wechat.svg" alt="">
                  <span class="vx-login">微信登录</span>
                </div>
              </a>
            </div> 
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import localStorageHelper from '@/helpers/localStorageHelper';
import { AUTH_TOKEN_KEY } from '@/helpers/constants';

export default {
  data() {
    return {
      verificationCodeLoginCodeError: '',
      verificationCodeLoginTelError: '',
      showLoginCodeBtn: true,
      dialogVisible: false,
      selectedOptionTab: 'login',
      usernameLoginInput: '',
      usernamePasswordLoginInput: '',
      isPasswordLogin: true,
      telLoginInput: '',
      verificationCodeLoginInput: '',
      telRegisterInput: '',
      passwordRegisterInput: '',
      verificationCodeRegisterInput: '',
      registerTelError: '',
      registerPasswordError: '',
      registerVerificationError: '',
      showCodeBtn: true,
      time: 0,
      usernameLoginUsernameError: '',
      usernameLoginPasswordError: '',
      redirectUri: ''
    };
  },
  methods: {
    verificationCodeLoginInputFocus() {
      this.verificationCodeLoginTelError = '';
      this.verificationCodeLoginCodeError = '';
    },
    verificationCodeInputFocus() {
      this.verificationCodeLoginTelError = '';
      this.verificationCodeLoginCodeError = '';
    },
    onChooseVerificationLogin() {
      this.isPasswordLogin = false;
      this.telLoginInput = '';
      this.verificationCodeLoginInput = '';
      this.showLoginCodeBtn = true;
    },
    onChoosePasswordLogin() {
      this.isPasswordLogin = true;
      this.usernameLoginInput = '';
      this.usernamePasswordLoginInput = '';
    },
    usernameLoginInputFocus() {
      this.usernameLoginUsernameError = '';
      this.usernameLoginPasswordError = '';
    },
    usernamePasswordLoginInputFocus() {
      this.usernameLoginUsernameError = '';
      this.usernameLoginPasswordError = '';
    },
    onDialogLoginClick() {
      if (this.isPasswordLogin) {
        if (!this.usernameLoginInput) {
          this.usernameLoginUsernameError = '用户名不能为空';
        } else if (!this.usernamePasswordLoginInput) {
          this.usernameLoginPasswordError = '密码不能为空';
        } else {
          QuestionQuery.login(this.usernameLoginInput, this.usernamePasswordLoginInput).then(res => {
            localStorageHelper.setItem(AUTH_TOKEN_KEY, res.token);
            this.dialogVisible = false;
            this.$emit('userLogin');
            eventBus.$emit('userLoginBus');
          },
          (err) => {
            this.usernameLoginPasswordError = err.data.message;
          });
        }
      } else if (!this.telLoginInput) {
        this.verificationCodeLoginTelError = '手机号不能为空';
      } else if (!this.verificationCodeLoginInput) {
        this.verificationCodeLoginCodeError = '验证码不能为空';
      } else {
        QuestionQuery.smsLogin(this.telLoginInput, this.verificationCodeLoginInput).then(res => {
          localStorageHelper.setItem(AUTH_TOKEN_KEY, res.token);
          this.dialogVisible = false;
          this.$emit('userLogin');
          eventBus.$emit('userLoginBus');
        },
        (err) => {
          this.verificationCodeLoginCodeError = err.data.message;
        });
      }
    },
    onSendLoginCodeClick() {
      if (!this.telLoginInput) {
        this.verificationCodeLoginTelError = '手机号不能为空';
      } else if (!/^1[3456789]\d{9}$/.test(this.telLoginInput)) {
        this.verificationCodeLoginTelError = '手机号不正确';
      } else {
        QuestionQuery.postSms(this.telLoginInput).then(() => {
          this.time = 60;
          this.showLoginCodeBtn = false;
          this.loginTimer();
        },
        (err) => {
          this.verificationCodeLoginCodeError = err.data.message;
        });
      }
    },
    loginTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.loginTimer, 1000);
      } else {
        this.time = 0;
        this.showLoginCodeBtn = true;
      }
    },
    onSendCodeClick() {
      if (!this.telRegisterInput) {
        this.registerTelError = '手机号不能为空';
      } else if (!/^1[3456789]\d{9}$/.test(this.telRegisterInput)) {
        this.registerTelError = '手机号不正确';
      } else {
        QuestionQuery.postSms(this.telRegisterInput).then(() => {
          this.time = 60;
          this.showCodeBtn = false;
          this.timer();
        },
        (err) => {
          this.registerTelError = err.data.message;
        });
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.showCodeBtn = true;
      }
    },
    onLoginClick() {
      this.dialogVisible = true;
      this.usernameLoginInput = '';
      this.usernamePasswordLoginInput = '';
      this.isPasswordLogin = true;
    },
    onKnowBtnClick() {
      this.dialogVisible = false;
    },
    onChooseDialogTab(res) {
      this.selectedOptionTab = res;
      if (this.selectedOptionTab === 'login') {
        this.telRegisterInput = '';
        this.passwordRegisterInput = '';
        this.verificationCodeRegisterInput = '';
        this.isPasswordLogin = true;
      } else {
        this.usernameLoginInput = '';
        this.usernamePasswordLoginInput = '';
        this.showCodeBtn = true;
      }
    },
    onRegisterClick() {
      if (!this.telRegisterInput) {
        this.registerTelError = '手机号不能为空';
      } else if (!/^1[3456789]\d{9}$/.test(this.telRegisterInput)) {
        this.registerTelError = '手机号不正确';
      } else if (!this.passwordRegisterInput) {
        this.registerPasswordError = '密码不能为空';
      } else if (!/^([a-zA-Z0-9]|[._]){8,16}$/.test(this.passwordRegisterInput)) {
        this.registerPasswordError = '密码可以是数字,大写或者小写字母, . , _ , 8到16位';
      } else if (!this.verificationCodeRegisterInput) {
        this.registerVerificationError = '验证码不能为空';
      } else {
        QuestionQuery.signup(this.telRegisterInput, this.passwordRegisterInput, this.verificationCodeRegisterInput).then(res => {
          this.registerTelError = '';
          this.registerPasswordError = '';
          this.registerVerificationError = '';
          this.dialogVisible = false;
          // eslint-disable-next-line 
          this.selectedOptionTab === 'login';
          localStorageHelper.setItem(AUTH_TOKEN_KEY, res.token);
          this.$emit('userLogin');
          eventBus.$emit('userLoginBus');
        },
        (err) => {
          this.registerVerificationError = err.data.message;
        });
      }
    },
    telRegisterInputFocus() {
      this.registerTelError = '';
      this.registerPasswordError = '';
      this.registerVerificationError = '';
    },
    passwordRegisterInputFocus() {
      this.registerTelError = '';
      this.registerPasswordError = '';
      this.registerVerificationError = '';
    },
    verificationCodeRegisterInputFocus() {
      this.registerTelError = '';
      this.registerPasswordError = '';
      this.registerVerificationError = '';
    }
  },
  created() {
    // eslint-disable-next-line
    this.redirectUri = `https://open.weixin.qq.com/connect/qrconnect?appid=wxa9c297bd00d0ada9&redirect_uri=https%3a%2f%2fyanbaocool.com%2f%23%2fredirect%2fwechat_callback&response_type=code&scope=snsapi_login#wechat_redirect`;
    // this.redirectUri = `https://open.weixin.qq.com/connect/qrconnect?appid=wxa9c297bd00d0ada9&redirect_uri=http%3a%2f%2f10.10.25.71%3a8080%2f%23%2fredirect%2fwechat_callback&response_type=code&scope=snsapi_login#wechat_redirect`;
  },
  mounted() {
    eventBus.$on('unLogin', () => {
      this.dialogVisible = true;
      this.usernameLoginInput = '';
      this.usernamePasswordLoginInput = '';
      this.isPasswordLogin = true;
    });
  }
};
</script>
<style lang="scss" scoped>
.login-dialog-btn {
  .login-btn {
    height: 32px;
    width: 95px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
}

/deep/.login-dialog {
  .login-dialog-content {
    height: 100%;
    width: 100%;
    .login-dialog-content-left {
      width: 376px;
      height: 100%;
      border-right: 1px solid #e5e6ee;
      .title {
        margin-bottom: 24px;
        color: #171f46;
        font-size: 24px;
        font-weight: 500;
      }
      .second-title {
        margin-bottom: 16px;
        line-height: 24px;
        color: #747990;
        font-size: 18px;
        font-weight: 500;
      }
      .content {
        margin-bottom: 32px;
        width: 316px;
        line-height: 22px;
        color: #747990;
      }
      .prompt {
        color: #0055ff;
        line-height: 24px;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 26px;
      }
      .login-left-btn {
        margin-top: 24px;
        margin-left: 114px;
        height: 32px;
        width: 88px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #171f46;
        background-color: rgba(0, 11, 92, 0.03);
        &:hover {
          color: #171f46;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:focus {
          color: #171f46;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:active {
          color: #171f46;
          background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
      }
    }
    .login-dialog-content-right {
      width: 412px;
      height: 100%;
      .login-dialog-content-right-content {
        height: 100%;
        width: 100%;
        padding-left: 60px;
        .login-right-img {
          width: 120px;
          height: 40px;
          margin-bottom: 40px;
        }
        .login-register-tab {
          position: relative;
          width: 100%;
          height: 54px; 
          line-height: 54px;
          font-size: 18px;
          font-weight: 500;
          color: #747990;
          box-shadow: inset 0px -1px 0px 0px#f2f3f7;
          .tab-btn {
            margin-right: 40px;
            cursor: pointer;
          }
          .active {
            position: relative;
            color: #171f46;
          }
          .active::after {
            content: '';
            position: absolute;
            bottom: 1px;
            left: 0;
            width: 36px;
            height: 2px;
            background-color: #171f46;
          }
        }
        .login-message {
          width: 100%;
          height: 216px; 
          padding-top: 32px;
          .input-error {
            position: absolute;
            line-height: 16px;
            color: #e64c62;
            font-size: 10px;
            font-weight: 500;
          }
          .password-login {
            position: relative;
          }
          .tel-login {

          }
          .tel-register {
            position: relative;
          }
          .verification-code-btn {
            margin: 16px 0 0 10px;
            height: 40px;
            width: 102px;
            padding: 0;
            border-radius: 2px;
            border: none;
            font-size: 14px;
            color: #747990;
            background-color: rgba(0, 11, 92, 0.03);
            &:hover {
              color: #747990;
              background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
              background-blend-mode: normal, normal;
            }
            &:focus {
              color: #747990;
              background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
              background-blend-mode: normal, normal;
            }
            &:active {
              color: #747990;
              background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
              background-blend-mode: normal, normal;
            }
          }
          .change-password-way {
            width: 56px !important;
          }
          .change-way {
            width: 98px;
            margin-top: 16px;
            color: #0055ff;
            line-height: 22px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
          }
          .password-input {
            margin-top: 16px;
          }
          .verification-code-input {
            width: 240px !important;
            margin-top: 16px;
          }
          .login-register-input {
            width: 352px;
            height: 40px;
            line-height: 22px;
            padding: 0 16px;
            border-radius: 2px;
            border: 1px solid #e5e6ee;
            color: #171f46;
            font-size: 14px;
            outline: none;
            &::-webkit-input-placeholder {
              color: #d1d2da;
            }
            &::-moz-placeholder {
              color: #d1d2da;
            }
            &::-ms-input-placeholder {
              color: #d1d2da;
            }
            &:hover {
              border: 1px solid #999ebe;
            }
            &:focus {
              border: 1px solid #171f46;
            }
          }
        }
        .login-register-btn {
          .vx-login--btn {
            height: 40px;
            line-height: 40px;
            width: 352px;
            border-radius: 2px;
            font-size: 14px;
            color: #747990;
            font-weight: 500;
            text-align: center;
            background-color: rgba(0, 11, 92, 0.03);
            cursor: pointer;
            // &:hover {
            //   color: #747990;
            //   background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            //   background-blend-mode: normal, normal;
            // }
            // &:focus {
            //   color: #747990;
            //   background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            //   background-blend-mode: normal, normal;
            // }
            // &:active {
            //   color: #747990;
            //   background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            // background-blend-mode: normal, normal;
            // }
            .wechat-img {
              margin-bottom: -5px;
              margin-right: 6px;
            }
            .vx-login {
              color: #747990;
            }
          }
          .login--btn {
            margin-bottom: 16px;
            width: 352px;
            height: 40px;
            line-height: 40px;
            border-radius: 2px;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            background-color: #0055ff;
            cursor: pointer;
            &:hover {
              color: #ffffff;
              background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
              background-blend-mode: normal, normal;
            }
            &:focus {
              color: #ffffff;
              background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
              background-blend-mode: normal, normal;
            }
            &:active {
              color: #ffffff;
              background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
              background-blend-mode: normal, normal;
            }
          }
        }
      }
    }
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px 24px 14px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      height: 528px;
      // overflow: auto;
      padding: 22px 60px 60px;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
a {
  text-decoration: none;
}
</style>
